import { Fragment, h } from '@stencil/core';
import { pesCatalogPageTypes, ConfiguratorHandler } from '@pes-ui/utils';
import { PesRouterStore } from '../../index';
import { getFilteredBreadcrumbs } from '../breadcrumbs/utils';
import { addHostToHmcUrls } from '../UI/help-me-choose/utils';
import { getCountry, getLanguage } from '../../globals/utils/helpers';
export class PesAppCategorySubcategoryListing {
  constructor() {
    var _a;
    this.hyperPersonalizationFlag = (_a = ConfiguratorHandler.getSingleConfig('FeatureFlags')) === null || _a === void 0 ? void 0 : _a.hyperPersonalization;
    this.isHyperPersonalizationEnabled = ConfiguratorHandler.isFeatureFlagEnabled(this.hyperPersonalizationFlag || {});
    this.host = undefined;
    this.showBreadcrumbs = undefined;
    this.categoryOrSubcategoryId = undefined;
    this.showDocuments = true;
    this.enableCommerceConnector = true;
    this.showBuyOnline = true;
    this.showCompare = true;
    this.searchParams = {};
    this.productCtas = undefined;
    this.breadcrumbs = undefined;
    this.descriptionInfo = undefined;
    this.listingInfo = undefined;
    this.hmcBannerInfo = undefined;
    this.isPBS = false;
    this.isSubcategoryPage = false;
    this.storageName = undefined;
    this.currentPageStorageKey = undefined;
    this.analyticsPageData = undefined;
  }
  componentWillRender() {
    if (this.isPBS)
      PesRouterStore.set('enableAppRouting', true);
  }
  get customBreadcrumbs() {
    if (!this.showBreadcrumbs) {
      return null;
    }
    return getFilteredBreadcrumbs(this.breadcrumbs.breadcrumbs, this.isPBS ? undefined : []);
  }
  get hmcBanner() {
    if (!this.hmcBannerInfo) {
      return null;
    }
    addHostToHmcUrls(this.host, this.hmcBannerInfo);
    return this.hmcBannerInfo;
  }
  render() {
    const { hideOnMobile } = this.breadcrumbs;
    const { name, description, readLessLabel, readMoreLabel, badge = null } = this.descriptionInfo;
    const { localeCode, productsUrl, hideHMCBanner = false, subcategorySection, productsSection, filtersSection, navigationState, filtersUrl, rangesUrl, numberOfProducts, hiddenSubcategoriesInfo, pageParam, } = this.listingInfo;
    return (h(Fragment, null, h("div", { class: this.isSubcategoryPage ? 'subcategories__listing__main' : '' }, this.showBreadcrumbs && (h("pes-breadcrumbs", { breadcrumbs: this.customBreadcrumbs, hideOnMobile: hideOnMobile, hostWithLocale: this.storageName })), h("pes-category-heading", { name: name, description: description, readLessLabel: readLessLabel, readMoreLabel: readMoreLabel, badge: badge }), this.isHyperPersonalizationEnabled
      && (!this.isSubcategoryPage)
      && (h("pes-recommendations", { class: 'listing-page-recommendations', pageType: pesCatalogPageTypes.CATEGORY, pageId: this.categoryOrSubcategoryId, countryCode: getCountry(localeCode), languageCode: getLanguage(localeCode), isLoggedIn: this.isPBS })), !this.isPBS && (h("slot", { name: "content-article-slide-carousel" })), h("pes-spryker-category-subcategory-listing", { host: this.host, localeCode: localeCode, subcategorySection: subcategorySection, productsSection: productsSection, filtersSection: filtersSection, hmcBanner: this.hmcBanner, hideHMCBanner: hideHMCBanner, navigationState: navigationState, filtersUrl: filtersUrl, productsUrl: productsUrl, rangesUrl: rangesUrl, numberOfProducts: numberOfProducts, showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, showCompare: this.showCompare, enableCommerceConnector: this.enableCommerceConnector, avoidAccents: false, hiddenSubcategoriesInfo: hiddenSubcategoriesInfo, pageParam: pageParam, isPBS: this.isPBS, searchParams: this.searchParams, isSubcategoryPage: this.isSubcategoryPage, productCtas: this.productCtas, currentPageStorageKey: this.currentPageStorageKey, storageName: this.storageName, analyticsPageData: this.analyticsPageData }))));
  }
  static get is() { return "pes-app-category-subcategory-listing"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-app-category-subcategory-listing.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-app-category-subcategory-listing.css"]
    };
  }
  static get properties() {
    return {
      "host": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "https://www.se.com:9090"
            }],
          "text": "The host of the endpoints."
        },
        "attribute": "host",
        "reflect": false
      },
      "showBreadcrumbs": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show the breadcrumbs."
        },
        "attribute": "show-breadcrumbs",
        "reflect": false
      },
      "categoryOrSubcategoryId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "4200"
            }],
          "text": "The ID of the category."
        },
        "attribute": "category-or-subcategory-id",
        "reflect": false
      },
      "showDocuments": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show the documents."
        },
        "attribute": "show-documents",
        "reflect": false,
        "defaultValue": "true"
      },
      "enableCommerceConnector": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show the commerce connector."
        },
        "attribute": "enable-commerce-connector",
        "reflect": false,
        "defaultValue": "true"
      },
      "showBuyOnline": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show the buy online."
        },
        "attribute": "show-buy-online",
        "reflect": false,
        "defaultValue": "true"
      },
      "showCompare": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show the compare."
        },
        "attribute": "show-compare",
        "reflect": false,
        "defaultValue": "true"
      },
      "searchParams": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TSearchParams",
          "resolved": "{ [x: string]: string; }",
          "references": {
            "TSearchParams": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "{}"
      },
      "productCtas": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductCtas",
          "resolved": "{ buttons: TProductCtasButtons; productProp?: string; }",
          "references": {
            "TProductCtas": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Setup productCtas logic.\nbuttons - predefined CTA buttons.\nproductProp - predefined property of product to find in list."
        }
      },
      "breadcrumbs": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TBreadcrumbsData",
          "resolved": "{ breadcrumbs: TBreadcrumbs[]; hideOnMobile: boolean; }",
          "references": {
            "TBreadcrumbsData": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "descriptionInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TDescriptionInfo",
          "resolved": "{ name: string; description: string; readMoreLabel: string; readLessLabel: string; badge?: TProductBadge; }",
          "references": {
            "TDescriptionInfo": {
              "location": "import",
              "path": "../../global-types/api/category-subcategory-api-common"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "listingInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TListingInfo",
          "resolved": "{ hmcBanner?: THMCBanner; hideHMCBanner?: boolean; filtersSection: TFiltersSection; filtersUrl: string; hiddenSubcategoriesInfo: TSubCategory[]; localeCode: string; navigationState: string; numberOfProducts: string; pageParam: string; productsSection: ProductsSection; productsUrl: string; rangesUrl: string; subcategorySection: TSubCategorySection; }",
          "references": {
            "TListingInfo": {
              "location": "import",
              "path": "../pes-app-category-listing/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "hmcBannerInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "THMCBanner",
          "resolved": "{ sourceId?: string; parentCategoryId?: string; categoryName?: string; labels?: THMCBannerLabels; hasQuestionnaire?: boolean; categoryProductConfiguratorUrl?: string; questionnaireUrl?: string; rangeTooltipUrl?: string; selectorConfigUrl?: string; isExternalProductConfiguratorUrl?: boolean; pimId?: string; host?: string; token?: string; channel?: string; pageSource?: string; }",
          "references": {
            "THMCBanner": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-p-b-s",
        "reflect": false,
        "defaultValue": "false"
      },
      "isSubcategoryPage": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-subcategory-page",
        "reflect": false,
        "defaultValue": "false"
      },
      "storageName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "storageName in indexDB for saving breadcrumbs"
        },
        "attribute": "storage-name",
        "reflect": false
      },
      "currentPageStorageKey": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "SUBCATEGORY/4200"
            }],
          "text": "key for getting breadcrumbs from the indexDB"
        },
        "attribute": "current-page-storage-key",
        "reflect": false
      },
      "analyticsPageData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "MetaTags['analyticsPageData']",
          "resolved": "{ articleTitle: string | number; businessUnit: string; pageRangeId: string; pageSubCategoryId: string; pageCategoryId: string; pageSubCategory: string; pageProductId: string; fromWebView: boolean; digitalPlatform: string; digitalPlatformCountry: string; pageLanguage: string; environment: string; template: string; pageSubSubCategory: string; pageTopCategory: string; pageCategory: string; pageTitle: string; }",
          "references": {
            "MetaTags": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
}
